/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
export var PlatformType;
(function (PlatformType) {
    PlatformType["App"] = "app";
    PlatformType["Web"] = "web";
})(PlatformType || (PlatformType = {}));
//# sourceMappingURL=PlatformType.js.map